import { motion } from 'framer-motion'
import './WhatIsFlashUSDT.css'

export default function WhatIsFlashUSDT() {
    const features = [
        {
            title: 'Atomic Off-Chain Settlement',
            description: 'Execute high-velocity USDT operations through our institutional-grade settlement system. Your funds are cryptographically secured throughout the entire transaction lifecycle, ensuring zero counterparty risk while maintaining sub-200ms propagation delay.'
        },
        {
            title: 'USDT-First Architecture',
            description: 'Purpose-built infrastructure optimized exclusively for USDT transactions. Native TRC20, ERC20, and TON support with automatic network detection, algorithmic routing optimization, and seamless cross-chain settlement rails—all without intermediaries or hidden fees.'
        },
        {
            title: 'High-Throughput Execution',
            description: 'Capture time-sensitive opportunities with our globally distributed node network. Enterprise-grade infrastructure delivers atomic settlement with 99.9% network throughput efficiency, backed by <100ms API latency and real-time status monitoring.'
        }
    ]

    return (
        <section className="what-section" id="about">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="section-title">
                        What is <span className="text-neon">TetherStream Protocol</span>?
                    </h2>
                    <p className="section-subtitle">
                        The institutional-grade protocol for high-velocity USDT settlement.
                        Zero intermediaries. Zero delays. Zero compromise.
                    </p>
                </motion.div>

                <div className="features-grid">
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            className="feature-card glass"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.2 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <div className="feature-icon">
                                <div className="icon-glow"></div>
                                <span className="icon-text">{String(index + 1).padStart(2, '0')}</span>
                            </div>
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">{feature.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}
